import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

export class ComputingOption implements RequestModelInterface
{
    public constructor(
        public parametersType: ComputingOption.ParametersType,
        public compartmentOption: ComputingOption.CompartmentOption|null,
        public retrieveStatistics: boolean,
        public retrieveParameters: boolean,
        public retrieveCovariates: boolean,
    )
    {
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("computingOption");

        element.appendNewElement("parametersType", this.parametersType);
        element.appendNewElement("compartmentOption", this.compartmentOption);
        element.appendNewElement("retrieveStatistics", this.retrieveStatistics.toString());
        element.appendNewElement("retrieveParameters", this.retrieveParameters.toString());
        element.appendNewElement("retrieveCovariates", this.retrieveCovariates.toString());

        return element;
    }
}

export namespace ComputingOption
{
    export enum ParametersType {
        POPULATION = "population",
        APRIORI = "apriori",
        APOSTERIORI = "aposteriori",
    }
    
    export enum CompartmentOption {
        ALL_ACTIVE_MOIETIES = "allActiveMoieties",
        ALL_ANALYTES = "allAnalytes",
        ALL_COMPARTMENTS = "allCompartments",
        SPECIFIC = "specific",
    }
}
